import axios from "axios";

const instance = axios.create({
  // baseURL: 'http://localhost:4000',
  baseURL: 'http://api.aircareavionics.co.ke',
});

export default instance